// extracted by mini-css-extract-plugin
export default {"element":"ImageCentered-module--element--d9b94","small":"ImageCentered-module--small--255e8"};